<template>
  <div class="assess">
    <!-- 管理端 -->
    <a-tabs v-model:activeKey="activeKey" @change="tabChange" v-if="!store.roles.includes('carEnterprise')">
      <a-tab-pane v-for="item in tabList" :key="item.value" :tab="item.name">
        <div class="query-item">
          <div class="search-l">
            <div>
              企业名称
              <a-input class="inp ml24" placeholder="请输入" v-model:value="query.deptName"></a-input>
            </div>
            <div class="ml30">
              测试牌照
              <a-input class="inp ml24" placeholder="请输入" v-model:value="query.testCarNum"></a-input>
            </div>
            <a-button class="ml24" @click="search" type="primary" ghost>查询</a-button>
            <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
          </div>
        </div>
        <a-table :columns="activeKey === 0 ? columns : columns1" :row-key="(record) => record.id"
          :data-source="dataSource" class="mt23" size="middle" :pagination="pagination" :scroll="{ x: 1500, y: 'auto' }"
          v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'createTime'">
              {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
            <template v-if="column.key === 'category'">
              {{
                record.category == 0 ? "一般道路测试评估" : "高速道路测试评估"
              }}
            </template>
            <template v-if="column.key === 'checkResult'">
              {{ record.checkResult === 0 ? "拒绝" : "同意" }}
            </template>
            <template v-if="column.key === 'status'">
              {{
                record.checkResult === 0
                  ? "-"
                  : record.status === 0
                    ? "待生成"
                    : record.status === 1
                      ? "已生成"
              : "-"
              }}
            </template>
            <template v-if="column.key === 'purview'">
              <a-switch v-model:checked="record.purview" checked-children="启用" un-checked-children="禁用" />
            </template>
            <template v-else-if="column.key === 'action'">
              <span v-if="activeKey === 0">
                <a v-if="store.hasPermi('report:access:review')" @click="detail(record)">审批</a>
              </span>
              <span v-else>
                <a-popconfirm title="确定生成评估报告?" ok-text="确定" cancel-text="取消" @confirm="getGenerateReport(record)">
                  <a v-if="record.checkResult === 1 && record.status === 0">生成评估报告</a>
                </a-popconfirm>

                <div v-if="record.checkResult === 1 && record.status === 1">
                  <a @click="uploadReport(record)">上传</a>
                  <a :href="record.reportFileUrl" target="_blank" class="mr10">下载</a>
                  <a class="mr10" @click="assessReport(record)">评估报告</a>
                </div>
                <div v-if="record.checkResult === 0">-</div>
              </span>
            </template>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>

    <!-- 车企端 -->
    <div class="query-item" v-if="store.roles.includes('carEnterprise')">
      <div class="search-l">
        <div>
          测试牌照
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.testCarNum"></a-input>
        </div>
        <a-button class="ml24" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
        <div></div>
      </div>
      <div>
        <a-button class="ml24" @click="add" type="primary">申请评估</a-button>
      </div>
    </div>
    <a-table v-if="store.roles.includes('carEnterprise')" :columns="columns2" :row-key="(record) => record.id"
      :data-source="dataSource" class="mt23" size="middle" :pagination="pagination" :scroll="{ x: 1500, y: 'auto' }"
      v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'createTime'">
          {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template v-if="column.key === 'category'">
          {{ record.category == 0 ? "一般道路测试评估" : "高速道路测试评估" }}
        </template>
        <template v-if="column.key === 'checkResult'">
          {{ record.checkResult === 0 ? "拒绝" : "同意" }}
        </template>
        <template v-if="column.key === 'status'">
          {{
            record.status === 0
              ? "待审批"
              : record.status === 1
                ? "已审批"
                : "-"
          }}
        </template>
        <template v-if="column.key === 'purview'">
          <a-switch v-model:checked="record.purview" checked-children="启用" un-checked-children="禁用" />
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <div v-if="record.checkResult != 1">
              <a @click="assessReport(record)">评估报告</a>
            </div>
            <div v-if="record.checkResult == 1">-</div>
          </span>
        </template>
      </template>
    </a-table>

    <!-- 审批 -->
    <reviewModal :modalTitle="'审批'" :modalWidth="'446px'" :isDetailStatus="true" ref="modalRef" :confirmFlag="true"
      @saveEvent="auditSaveEvent" @cancelEvent="auditCancelEvent">
      <div class="audit_content">是否同意生成评估报告？</div>
    </reviewModal>

    <!-- 上传 -->
    <reviewModal :modalTitle="'上传报告'" :modalWidth="'702px'" :isDetailStatus="true" ref="modalRefJoint"
      @saveEvent="uploadSaveEvent" @cancelEvent="uploadCancelEvent">
      <div class="newDetail">
        <div class="mt16">
          <upload :pathName="'car'" ref="uploadRef" accept=".xls,.docx,.doc" @uploadFinished="uploadFinished"
            :assessStatus="true">
          </upload>
        </div>
      </div>
    </reviewModal>

    <!-- 申请评估 -->
    <reviewModal :modalTitle="'申请'" :modalWidth="'702px'" :isDetailStatus="true" :confirmDisabled="confirmDisabled"
      ref="modalApplyForRef" @saveEvent="applySaveEvent" @cancelEvent="applyCancelEvent">
      <div class="detail add">
        <div class="cars">
          <div class="item">
            <div class="tit">测试牌照</div>
            <a-select v-model:value="applyForData.carId" style="width: 100%" placeholder="请选择"
              @change="testCarNumChange">
              <a-select-option v-for="item in testCarNumList" :key="item.id" :value="item.id">{{ item.testCarNum
              }} <span v-if="item.testCarNum">/</span> {{ item.frameNum }}</a-select-option>
            </a-select>
          </div>
          <div class="item">
            <div class="tit">评估类型</div>
            <!-- <a-select v-model:value="applyForData.category" style="width: 100%" class="area_select" placeholder="请输入">
              <a-select-option v-for="(item, index) in typeList" :key="item.id" :value="item.dataCode + ''">{{
                item.dataValue }}</a-select-option>
            </a-select> -->
            <a-input :disabled="true" v-model:value="infoCha" style="width: 100%" class="area_select"
              placeholder="请输入"></a-input>
          </div>
        </div>
        <div class="message">
          请在申请前上传相应的《脱离报告》《急刹报告》《事故报告》
        </div>
      </div>
    </reviewModal>

    <assessDrawer ref="drawerRef"></assessDrawer>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  nextTick,
  watch,
  onActivated
} from "vue";
import { useRouter } from "vue-router";
import { FileTextOutlined } from "@ant-design/icons-vue";
import upload from "@/components/uploadProgress/index.vue";
import reviewModal from "@/components/modal/index.vue";
import assessDrawer from "./components/drawer.vue";
import { getCars } from "@/api/car/car.js";
import {
  selectPageList,
  check,
  generateReport,
  uploadFile,
  insertOne,
  getQualificationInfoDetailByCarId
} from "@/api/report/assess.js";
import { getSingleTypeValue } from "@/utils/matchDic.js";
import { message } from "ant-design-vue";

import useUserStore from "@/store/modules/user";
const store = useUserStore();

import useAppStore from "@/store/modules/app";
const appStore = useAppStore();

const router = useRouter();
const dataType = "reportEvaluationCategory";

const activeKey = ref(0);

const typeList = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType);
      typeList.value = val[index].children;
      console.log(typeList.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const columns = [
  {
    title: "编号",
    dataIndex: "ranking",
    key: "ranking",
    width: 100,
    fixed: "left",
  },
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
    // width: 150,
  },
  {
    title: "测试牌照",
    key: "testCarNum",
    dataIndex: "testCarNum",
  },
  {
    title: "评估类型",
    key: "category",
  },
  {
    title: "更新时间",
    key: "updateTimeStr",
    dataIndex: "updateTimeStr",
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 240,
  },
];
const columns1 = [
  {
    title: "编号",
    dataIndex: "ranking",
    key: "ranking",
    width: 100,
    fixed: "left",
  },
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
    // width: 150,
  },
  {
    title: "测试牌照",
    key: "testCarNum",
    dataIndex: "testCarNum",
  },
  {
    title: "评估类型",
    key: "category",
  },
  {
    title: "结果",
    key: "checkResult",
  },
  {
    title: "状态",
    key: "status",
  },
  {
    title: "更新时间",
    key: "updateTimeStr",
    dataIndex: "updateTimeStr",
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 240,
  },
];
const columns2 = [
  {
    title: "编号",
    dataIndex: "ranking",
    key: "ranking",
    width: 100,
    fixed: "left",
  },
  {
    title: "测试牌照",
    key: "testCarNum",
    dataIndex: "testCarNum",
  },
  {
    title: "评估类型",
    key: "category",
  },
  {
    title: "结果",
    key: "checkResult",
  },
  {
    title: "状态",
    key: "status",
  },
  {
    title: "更新时间",
    key: "updateTimeStr",
    dataIndex: "updateTimeStr",
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 240,
  },
];
const tabList = ref([
  { value: 0, name: "待审批" },
  { value: 1, name: "已审批" },
]);

let query = reactive({
  deptName: "",
  testCarNum: "",
});

const tabChange = (e) => {
  console.log(e);
  activeKey.value = e;
  pagination.current = 1;
  getData();
};

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.deptName = "";
  query.testCarNum = "";
  pagination.current = 1;
  getData();
};

let dataSource = ref([]);

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 20, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;

  // 获取表格数据
  getData();
}

function pageSizeChange(current, size) {
  console.log(size);
  pagination.pageSize = size;

  // 获取表格数据
  getData();
}

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query, approvalStatus: activeKey.value },
  };
  selectPageList(data).then((res) => {
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};

const applyForData = ref({
  carId: undefined,
  testCarNum: "",
  category: undefined,
  frameNum: '',
  qualificationId: ''
});

const resetApplyForData = () => {
  applyForData.value = {
    carId: undefined,
    testCarNum: "",
    category: undefined,
    frameNum: '',
    qualificationId: ''
  };
};

const modalRef = ref();
const modalRefJoint = ref();
const modalApplyForRef = ref();

// uploadRef.value.clearFileList()
const reportFileUrl = ref("");
const uploadFinished = (data) => {
  console.log(data, "111111111");
  reportFileUrl.value = data;
};
// 申请评估
const add = () => {
  modalApplyForRef.value.showModal();
  getCarsData();
};
// 申请评估确认
const applySaveEvent = () => {
  insertOne(applyForData.value).then((res) => {
    if (res.code === 200) {
      message.success("申请评估成功");
      // 获取表格数据
      getData();
      resetApplyForData();
    }
  });
};
// 申请评估取消
const applyCancelEvent = () => {
  resetApplyForData();
};

// 生成评估报告
const getGenerateReport = (record) => {
  console.log(record);
  generateReport({ id: record.id }).then((res) => {
    if (res.code === 200) {
      message.success("生成评估报告成功");
      // 获取表格数据
      getData();
    }
  });
};

const uploadID = ref("");
// 上传
const uploadReport = (record) => {
  console.log(record);
  uploadID.value = record.id;
  modalRefJoint.value.showModal();
};

const uploadRef = ref();
// 上传确认
const uploadSaveEvent = () => {
  uploadFile({ id: uploadID.value, reportFileUrl: reportFileUrl.value }).then(
    (res) => {
      if (res.code === 200) {
        message.success("上传成功");
        // 获取表格数据
        getData();
        uploadRef.value.reset();
      }
    }
  );
};

// 上传取消
const uploadCancelEvent = () => {
  uploadRef.value.reset();
};
const drawerRef = ref();
// 评估报告
const assessReport = (record) => {
  console.log(record);
  drawerRef.value.showDrawer(record);
};

const auditID = ref("");
// 审批
const detail = (record) => {
  console.log(record);
  auditID.value = record.id;
  modalRef.value.showModal();
};

const isCheck = (status, messageMeg) => {
  check({ id: auditID.value, checkResult: status }).then((res) => {
    if (res.code === 200) {
      message.success(messageMeg);
      // 获取表格数据
      getData();
    }
  });
};
// 同意
const auditSaveEvent = () => {
  console.log(123);
  isCheck(1, "同意");
};
// 拒绝
const auditCancelEvent = () => {
  console.log(111);
  isCheck(0, "拒绝");
};
const testCarNumList = ref([]);
const getCarsData = () => {
  getCars({
    pageIndex: 1,
    pageSize: 99,
    conditionMap: {
      deptName: "",
      frameNum: "",
      testCarNum: "",
      deptIdStr: store.deptId,
    },
  }).then((res) => {
    console.log(res);
    if (res.code === 200) {
      testCarNumList.value = res.data.records;
    }
  });
};

const infoCha = ref('')
const confirmDisabled = ref(false)
const testCarNumChange = (value) => {
  console.log(value);
  let res = testCarNumList.value.find((item) => item.id === value);
  console.log(res);
  applyForData.value.testCarNum = res.testCarNum;
  applyForData.value.frameNum = res.frameNum
  getQualificationInfoDetailByCarId(res.id).then(res => {
    console.log(res);
    if (res.code === 200) {
      applyForData.value.qualificationId = res.data.id
      if (!res.data.category) {
        message.error('无测试资格')
        confirmDisabled.value = true
      } else if (res.data.category === 'publicObject' || res.data.category === 'publicPerson') {
        message.error('一般道路示范应用不需要申请测试评估！')
        confirmDisabled.value = true
      } else if (res.data.category === 'freewayDemonstrate') {
        message.error('高速公路示范应用不需要申请测试评估！')
        confirmDisabled.value = true
      } else {
        confirmDisabled.value = false
      }

      let info = getSingleTypeValue(appStore.SysDictVOList, 'testType' + 'category' + res.data.category)
      console.log(info);

      infoCha.value = info

      if (infoCha.value === '一般道路测试') {
        applyForData.value.category = 0
      } else if (infoCha.value === "高速公路测试") {
        applyForData.value.category = 1
      }

      // applyForData.value.category = res.data.category;

    }
  })

};

// onActivated(async () => {
// getData();
// });
onMounted(() => {
  getData();
});

</script>
<style lang="less" scoped>
.assess {
  padding: 13px 20px 20px 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

.modal_item {
  padding: 0 26px 106px 23px;
  background: #f6f8fa;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;

  .file_text {
    padding-top: 19px;
    border-bottom: 1px solid #d4e0f0;

    .fil_it {
      display: flex;
      align-items: center;
      padding-left: 49px;
      padding-bottom: 19px;

      .file_tit {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #6c7683;
      }

      .file_ic {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1d2129;
      }
    }

    .file_icon {
      color: rgba(24, 111, 242, 1);
    }
  }
}

.mr10 {
  margin-left: 10px;
}

a {
  color: #1e8ef2;
}

.radio_class {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: rgba(29, 33, 41, 1);
}

.area_class {
  // display: flex;
}

.area_width {
  // width: 420px;
  // margin-left: 26px;
  margin-top: 22px;
}

.mt22 {
  margin-top: 22px;
}

.mt32 {
  margin-top: 32px;
}

.mb85 {
  margin-bottom: 85px;
}

.mb26 {
  margin-bottom: 26px;
}

.ml26 {
  margin-left: 26px;
}

.pl30 {
  padding-left: 30px;
}

.pl43 {
  padding-left: 43px;
}

.pl15 {
  padding-left: 15px;
}

.pl55 {
  padding-left: 55px;
}

.pl60 {
  padding-left: 60px;
}

.pl64 {
  padding-left: 64px;
}

.audit_content {
  text-align: center;
  margin: 24px 0 59px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}

.newDetail {
  padding: 70px 60px;

  .filelist {
    border: 1px solid #e1e7ef;
    padding: 20px 0;
    text-align: center;
    width: 513px;
    height: 120px;
    background: #f6f8fa;
    margin-left: 41px;

    .item {
      color: #636d7b;
      font-size: 14px;

      .anticon {
        color: #186ff2;
        margin-right: 13px;
      }
    }

    .btns {
      margin-top: 19px;
    }
  }
}

.detail {
  padding: 30px 60px 53px 60px;

  .cars {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;

    .item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    .tit {
      //   padding: 11px 33px;
      font-weight: 600;
      color: #1d2129;
      width: 125px;
      //   padding: 11px;
      text-align: right;

      margin-right: 25px;
    }

    .cont {
      padding: 15px 28px;
    }
  }
}

.message {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #f90000;
  margin-left: 118px;
}

/deep/.ant-tabs .ant-tabs-tab {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  margin: 0 0 0 70px;
  color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #1d2129;
}

/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
  height: 3px;
  // background: rgba(30, 142, 242, 1);
}

/deep/.ant-upload-wrapper .ant-upload-list {
  width: 130px;
}

/deep/.ant-input[disabled] {
  background-color: #eee;
}
</style>
